import { ProfileModel } from '@pukka/api';

const defaultPermissions = [
  {
    id: 1,
    priority_rank: 10,
    menu: 'Dashboard',
    menu_name: 'View Dashboard',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: true,
    urls: [
      '/dashboard',
      '/api/v1/dashboard',
      '/reporting/v1/dashboard/lists',
      '/sync-bill/v1/bills/stats',
      '/reporting/v1/dashboard/sales_summary',
      '/reporting/v1/dashboard/item_summary',
    ],
    sub_menu: 'Dashboard',
    sub_menu_name: 'View Dashboard',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 2,
    priority_rank: 20,
    menu: 'Reports',
    menu_name: 'View Reports',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: true,
    urls: [
      '/reports/sales/summary',
      '/reports/sales/gross_profit',
      '/reports/sales/payment_methods',
      '/reports/sales/item_sales',
      '/reports/sales/category_sales',
      '/reports/sales/modifier_sales',
      '/reports/sales/discounts',
      '/reports/sales/taxes',
      '/reports/sales/gratuity',
      '/reports/sales/staff',
      '/reports/sales/server',
      '/api/v1/reports/category_sales',
      '/api/v1/reports/discounts',
      '/api/v1/reports/export_category_sales',
      '/api/v1/reports/export_discounts',
      '/api/v1/reports/export_gratuities',
      '/api/v1/reports/export_gross_profit',
      '/api/v1/reports/export_item_sales',
      '/api/v1/reports/export_modifiers',
      '/api/v1/reports/export_payment_methods',
      '/api/v1/reports/export_sales_summary',
      '/api/v1/reports/export_servers',
      '/api/v1/reports/export_staff_report',
      '/api/v1/reports/export_taxes',
      '/api/v1/reports/gratuities',
      '/api/v1/reports/gross_profit',
      '/api/v1/reports/modifiers',
      '/api/v1/reports/payment_methods',
      '/api/v1/reports/sales_summary',
      '/api/v1/reports/servers',
      '/api/v1/reports/staff_report',
      '/api/v1/reports/taxes',
      '/api/v2/reports/item_sales',
      '/reports/sales/sales_type',
      '/api/v1/reports/sales_type',
      '/api/v1/reports/export_sales_type',
      '/report/v1/discounts/export',
      '/report/v1/discounts',
      '/reporting/v1/reports/sales_summary',
      '/reporting/v1/reports/gross_profit',
      '/reporting/v1/reports/export_sales_summary',
      '/reporting/v1/reports/export_gross_profit',
      '/reporting/v1/reports/item_sales',
      '/reporting/v1/reports/export_item_sales',
      '/reporting/v1/reports/category_sales',
      '/reporting/v1/reports/export_category_sales',
      '/reporting/v1/reports/payment_methods',
      '/reporting/v1/reports/export_payment_methods',
      '/reports/sales/hourly_item/sold',
      '/reporting/v1/reports/hourly/item_sold',
      '/reporting/v1/reports/export_item_sold',
      '/reports/sales/hourly_item/amount',
      '/reporting/v1/reports/hourly/item_amount',
      '/reporting/v1/reports/export_item_amount',
    ],
    sub_menu: 'Sales',
    sub_menu_name: 'Sales',
    is_allowed_for_moka_pay: true,
    withRedDot: true,
  },
  {
    id: 3,
    priority_rank: 30,
    menu: 'Reports',
    menu_name: 'View Reports',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: true,
    urls: [
      '/reports/transactions',
      '/api/v1/email_receipt',
      '/api/v1/reports/\\d+/transaction_detail',
      '/api/v1/reports/export_transactions',
      '/api/v1/reports/transactions',
      '/api/v2/refunds',
      '/api/v1/reports/export_by_item',
    ],
    sub_menu: 'Transactions',
    sub_menu_name: 'Transactions',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 4,
    priority_rank: 40,
    menu: 'Reports',
    menu_name: 'View Reports',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: true,
    urls: [
      '/reports/invoices',
      '/api/v1/invoices/\\d+.json',
      '/api/v1/invoices/\\d+/resend_email',
      '/api/v1/invoices/export',
      '/api/v1/invoices/payment_records',
      '/api/v1/reports/invoices',
      '/api/v2/refunds',
      '/api/v1/invoices/\\d+.pdf',
    ],
    sub_menu: 'Invoices',
    sub_menu_name: 'Invoices',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 5,
    priority_rank: 50,
    menu: 'Reports',
    menu_name: 'View Reports',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: true,
    urls: [
      '/reports/shifts',
      '/api/v1/cash_drawer/shifts',
      '/api/v1/cash_drawer/shifts/\\d+',
      '/api/v1/cash_drawer/shifts/export',
      '/api/v1/cash_drawer/shifts/summary',
    ],
    sub_menu: 'Shift',
    sub_menu_name: 'Shifts',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 6,
    priority_rank: 60,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/list',
      '/api/v1/categories/with_uncategorized',
      '/api/v1/ingredients/have_recipe',
      '/api/v1/items',
      '/api/v1/items',
      '/api/v1/items/\\d+',
      '/api/v1/items/create_all_outlet',
      '/api/v1/items/import_items',
      '/api/v1/items/import_items_template',
      '/api/v1/items/import_items_temporary',
      '/api/v1/items/new',
      '/api/v1/items/summary',
      '/api/v1/modifiers',
      '/api/v1/s3/new',
      '/api/v1/items/\\d+/update_image',
      '/api/v1/items/\\d+',
      '/api/v1/items/\\d+',
      '/library/v1/sales-type',
      '/loyalty/v2/programs',
      '/library/v1/items',
      '/api/v3/items',
      '/api/v3/items',
      '/api/v3/items',
      '/api/v3/items',
      '/api/v3/items/validate_create_all_outlet',
      '/api/v3/items/create_all_outlet',
      '/api/v3/items/import_items',
      '/api/v3/items/import_items_temporary',
      '/api/v3/items/import_items_template',
      '/api/v3/items/get_modifiers_list',
      '/loyalty/v3/programs',
      '/api/v1/items/\\d+/delete_all_outlet',
    ],
    sub_menu: 'Item Library',
    sub_menu_name: 'Item Library',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 7,
    priority_rank: 70,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/modifier',
      '/api/v1/modifiers',
      '/api/v1/modifiers/\\d+/apply_to_items',
      '/api/v1/modifiers/\\d+/delete_modifier',
      '/api/v1/modifiers/\\d+',
      '/api/v1/modifiers/create_all_outlet',
      '/api/v2/items',
      '/api/v2/modifiers',
      '/library/v1/items',
    ],
    sub_menu: 'Modifiers',
    sub_menu_name: 'Modifiers',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 8,
    priority_rank: 80,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/categories',
      '/api/v1/categories',
      '/api/v1/categories/\\d+',
      '/api/v1/categories/\\d+',
      '/api/v1/categories/\\d+/move_items',
      '/api/v1/categories/\\d+',
      '/api/v1/categories/create_all_outlet',
      '/api/v1/items',
      '/api/v2/categories',
      '/api/v2/items',
      '/api/v1/categories',
      '/loyalty/v2/programs',
      '/library/v1/items',
      '/loyalty/v3/programs',
    ],
    sub_menu: 'Categories',
    sub_menu_name: 'Item Categories',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 10,
    priority_rank: 100,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/discounts',
      '/api/v1/discounts',
      '/api/v1/discounts/\\d+',
      '/api/v1/discounts/\\d+',
      '/api/v1/discounts/create_all_outlet',
      '/api/v2/discounts',
    ],
    sub_menu: 'Discounts',
    sub_menu_name: 'Discounts',
    is_allowed_for_moka_pay: true,
    isPukka: true,
  },
  {
    id: 11,
    priority_rank: 110,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/library/taxes',
      '/api/v1/taxes',
      '/api/v1/taxes/\\d+',
      '/api/v1/taxes/\\d+',
      '/api/v1/taxes/\\d+',
      '/api/v1/taxes/create_all_outlet',
      '/api/v2/taxes',
    ],
    sub_menu: 'Taxes',
    sub_menu_name: 'Taxes',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 12,
    priority_rank: 120,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/library/gratuity',
      '/api/v1/gratuities',
      '/api/v1/gratuities/\\d+',
      '/api/v1/gratuities/\\d+',
      '/api/v1/gratuities/\\d+',
      '/api/v1/gratuities/create_all_outlet',
      '/api/v2/gratuities',
    ],
    sub_menu: 'Gratuity',
    sub_menu_name: 'Gratuity',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 14,
    priority_rank: 140,
    menu: 'Ingredient',
    menu_name: 'Manage Ingredients',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/ingredient/list',
      '/api/v1/ingredient_categories/with_uncategorized',
      '/api/v1/ingredients',
      '/api/v1/ingredients',
      '/api/v1/ingredients/\\d+',
      '/api/v1/ingredients/\\d+',
      '/api/v1/ingredients/create_all_outlet',
      '/api/v1/ingredients/export',
      '/api/v1/ingredients/have_recipe',
      '/api/v1/ingredients/import',
      '/api/v1/ingredients/import_temp',
      '/api/v1/s3/new',
      '/api/v1/units',
    ],
    sub_menu: 'Ingredient Library',
    sub_menu_name: 'Ingredient Library',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 15,
    priority_rank: 150,
    menu: 'Ingredient',
    menu_name: 'Manage Ingredients',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/ingredient/categories',
      '/api/v1/ingredient_categories',
      '/api/v1/ingredient_categories',
      '/api/v1/ingredient_categories/\\d+/assigns',
      '/api/v1/ingredient_categories/\\d+',
      '/api/v1/ingredient_categories/\\d+',
      '/api/v1/ingredient_categories/create_all_outlet',
      '/api/v1/ingredients',
    ],
    sub_menu: 'Ingredient Categories',
    sub_menu_name: 'Ingredient Categories',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 16,
    priority_rank: 160,
    menu: 'Ingredient',
    menu_name: 'Manage Ingredients',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/ingredient/recipes',
      '/api/v1/ingredients',
      '/api/v1/items/item_dropdowns',
      '/api/v1/recipes',
      '/api/v1/recipes',
      '/api/v1/recipes/\\d+',
      '/api/v1/recipes/\\d+/update_all_outlets',
      '/api/v1/recipes/\\d+',
      '/api/v1/recipes/create_all_outlets',
      '/api/v1/recipes/export',
      '/api/v1/recipes/item_variants/\\d+',
    ],
    sub_menu: 'Recipes',
    sub_menu_name: 'Recipes',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 17,
    priority_rank: 170,
    menu: 'Inventory',
    menu_name: 'Manage Inventory',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/inventory/summary',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/inventory/summary',
      '/api/v1/inventory/summary/export',
      '/api/v1/ingredients_inventory/summary',
      '/api/v1/ingredients_inventory/summary/export',
    ],
    sub_menu: 'Summary',
    sub_menu_name: 'Inventory Summary',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 18,
    priority_rank: 180,
    menu: 'Inventory',
    menu_name: 'Manage Inventory',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/inventory/suppliers',
      '/api/v1/inventory/suppliers',
      '/api/v1/inventory/suppliers',
      '/api/v1/inventory/suppliers/\\d+',
      '/api/v1/inventory/suppliers/\\d+',
      '/api/v1/inventory/suppliers/export',
    ],
    sub_menu: 'Suppliers',
    sub_menu_name: 'Suppliers',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 19,
    priority_rank: 190,
    menu: 'Inventory',
    menu_name: 'Manage Inventory',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/inventory/purchase_orders',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/inventory/purchase_orders',
      '/api/v1/inventory/purchase_orders/\\d+.json',
      '/api/v1/inventory/purchase_orders/create_and_fulfilled',
      '/api/v1/inventory/purchase_orders/export',
      '/api/v1/inventory/purchase_orders/search',
      '/api/v1/inventory/suppliers',
      '/api/v1/items',
      '/api/v1/s3/new',
      '/api/v1/inventory/purchase_orders/\\d+',
      '/api/v1/ingredients_inventory/purchase_orders/\\d+',
      '/api/v1/ingredients_inventory/purchase_orders/search',
      '/api/v1/ingredients_inventory/purchase_orders/\\d+.json',
      '/api/v1/ingredients_inventory/purchase_orders/\\d+/edit.json',
      '/api/v1/ingredients/all',
      '/api/v1/ingredients_inventory/purchase_orders',
      '/api/v1/ingredients_inventory/purchase_orders/create_and_fulfilled',
      '/api/v1/ingredients_inventory/purchase_orders/export_template',
      '/api/v1/inventory/purchase_orders/export_template',
      '/api/v1/ingredients_inventory/purchase_orders/import_temporary',
      '/api/v1/ingredients_inventory/purchase_orders/import',
      '/api/v1/ingredients_inventory/purchase_orders/export',
      '/api/v1/inventory/purchase_orders/import_temporary',
      '/api/v1/inventory/purchase_orders/import',
    ],
    sub_menu: 'Purchase Order (PO)',
    sub_menu_name: 'Purchase Orders (PO)',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 20,
    priority_rank: 200,
    menu: 'Inventory',
    menu_name: 'Manage Inventory',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/inventory/transfer',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/inventory/transfer',
      '/api/v1/inventory/transfer',
      '/api/v1/inventory/transfer/export',
      '/api/v1/items',
      '/api/v1/ingredients/all',
      '/api/v1/ingredients_inventory/transfer/export',
      '/api/v1/ingredients_inventory/transfer',
      '/api/v1/ingredients_inventory/transfer',
    ],
    sub_menu: 'Transfer',
    sub_menu_name: 'View Transfer',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 21,
    priority_rank: 210,
    menu: 'Inventory',
    menu_name: 'Manage Inventory',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/inventory/adjustment',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/current_inventory_dropdown',
      '/api/v1/inventory/adjustment',
      '/api/v1/inventory/adjustment',
      '/api/v1/inventory/adjustment/export',
      '/api/v1/inventory/adjustment/import_adjustment_template',
      '/api/v1/inventory/adjustment/import_adjustments',
      '/api/v1/inventory/adjustment/import_adjustments_temporary',
      '/api/v1/items',
      '/api/v1/s3/new',
      '/api/v1/ingredients_inventory/adjustment',
      '/api/v1/ingredients/all',
      '/api/v1/ingredients_inventory/adjustment',
    ],
    sub_menu: 'Adjustment',
    sub_menu_name: 'Adjustments',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 22,
    priority_rank: 220,
    menu: 'Customers',
    menu_name: 'Manage Customers',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/customers/list',
      '/api/v1/customers/import_customers',
      '/api/v1/customers/import_customers_temporary',
      '/api/v1/invoices/\\d+.json',
      '/api/v1/reports/\\d+/transaction_detail',
      '/api/v1/s3/new',
      '/customer/v1/customers',
      '/customer/v1/customers/\\d+',
      '/customer/v1/customers/export',
      '/loyalty/v1/customers/\\d+/point-activities',
      '/loyalty/v1/customers/\\d+/redemptions',
      '/api/v1/invoices/\\d+.pdf',
      '/loyalty/v2/programs',
      '/loyalty/v3/programs',
    ],
    sub_menu: 'Customers List',
    sub_menu_name: 'Customer List',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 23,
    priority_rank: 230,
    menu: 'Customers',
    menu_name: 'Manage Customers',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/customers/feedback_list',
      '/api/v1/customer_feedbacks',
      '/api/v1/customer_feedbacks/\\d+/feedback_messages',
      '/api/v1/customer_feedbacks/submit_reply',
      '/api/v1/reports/\\d+/transaction_detail',
    ],
    sub_menu: 'Feedback',
    sub_menu_name: 'Feedback',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 24,
    priority_rank: 240,
    menu: 'Customers',
    menu_name: 'Manage Customers',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/customers/loyalty',
      '/loyalty/v1/programs',
      '/loyalty/v1/programs',
      '/loyalty/v1/programs',
      '/loyalty/v1/programs/deactivate',
      '/loyalty/v1/programs/reactivate',
      '/loyalty/v1/programs/reset',
      '/loyalty/v2/programs',
      '/loyalty/v2/programs',
      '/loyalty/v2/programs/\\d+',
      '/loyalty/v2/programs/\\d+/deactivate',
      '/loyalty/v2/programs/\\d+/reactivate',
      '/loyalty/v2/programs/\\d+/reset',
      '/loyalty/v2/programs/\\d+/stats',
      '/loyalty/v3/programs',
      '/loyalty/v3/programs',
      '/loyalty/v3/programs/\\d+',
      '/loyalty/v3/programs/\\d+/deactivate',
      '/loyalty/v3/programs/\\d+/reactivate',
      '/loyalty/v3/programs/\\d+/reset',
      '/loyalty/v3/programs/\\d+/stats',
    ],
    sub_menu: 'Loyalty Program',
    sub_menu_name: 'Loyalty Program',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 25,
    priority_rank: 250,
    menu: 'Employees',
    menu_name: 'Manage Employees',
    access: 'Back-office',
    level: 2,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/employees/staff',
      '/account/v1/employees',
      '/account/v1/employees',
      '/account/v1/employees/\\d+',
      '/account/v1/employees/\\d+',
      '/account/v1/roles',
      '/account/v1/employees/\\d+/permissions',
      '/api/v1/employees/resend_invitation',
      '/account/v1/slots',
      '/account/v1/slots/\\d+',
    ],
    sub_menu: 'Employee Slots',
    sub_menu_name: 'Employee Slots',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 26,
    priority_rank: 260,
    menu: 'Employees',
    menu_name: 'Manage Employees',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/employees/role',
      '/account/v1/roles',
      '/account/v1/roles',
      '/account/v1/roles/\\d+',
      '/account/v1/roles/\\d+',
      '/account/v1/employees/\\d+/permissions',
    ],
    sub_menu: 'Employee Access',
    sub_menu_name: 'Employee Access',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 27,
    priority_rank: 270,
    menu: 'Employees',
    menu_name: 'Manage Employees',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/employees/pin',
      '/account/v1/employees',
      '/account/v1/permissions/settings/pin',
      '/account/v1/permissions/settings/pin',
      '/account/v1/roles',
      '/account/v1/employees/\\d+/permissions',
    ],
    sub_menu: 'PIN Access',
    sub_menu_name: 'PIN Access',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 31,
    priority_rank: 530,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/outlets/list',
      '/api/v1/billings',
      '/api/v1/billings/outlet_price',
      '/api/v1/outlets',
      '/api/v1/outlets',
      '/api/v1/outlets/\\d+',
      '/api/v1/outlets/\\d+',
      '/v1/outlets/new',
    ],
    sub_menu: 'Outlets',
    sub_menu_name: 'Outlets',
    is_allowed_for_moka_pay: true,
    withRedDot: false,
  },
  {
    id: 32,
    priority_rank: 510,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: true,
    usable: false,
    urls: ['/settings/accounts', '/api/v1/users/settings'],
    sub_menu: 'Account',
    sub_menu_name: 'Account',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 33,
    priority_rank: 520,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: true,
    usable: false,
    urls: [
      '/settings/billing',
      '/api/v1/billings',
      '/api/v1/billings/rules',
      '/api/v1/feature/get_feature_price_per_months',
      '/api/v1/feature/get_subscription_status',
    ],
    sub_menu: 'Billing',
    sub_menu_name: 'Billing',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 34,
    priority_rank: 540,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/settings/public_profile', '/api/v1/businesses/\\d+'],
    sub_menu: 'Public Profile',
    sub_menu_name: 'Public Profile',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 35,
    priority_rank: 550,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/settings/receipt', '/api/v1/outlets/\\d+'],
    sub_menu: 'Receipt',
    sub_menu_name: 'Receipts',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 36,
    priority_rank: 560,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/settings/checkout', '/api/v1/checkout_setting', '/api/v1/settings/update_settings'],
    sub_menu: 'Checkout',
    sub_menu_name: 'Checkout',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 37,
    priority_rank: 580,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/settings/email', '/api/v1/settings/update_settings', '/api/v1/settings'],
    sub_menu: 'Email Notification',
    sub_menu_name: 'Email Notifications',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 9,
    priority_rank: 90,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/promo',
      '/promo/v1/promos',
      '/promo/v1/promos',
      '/promo/v1/promos/outlets',
      '/promo/v1/promos/outlets/\\d+',
      '/promo/v1/promos/\\d+',
      '/promo/v1/promos/\\d+',
      '/api/v1/items/intersect_category_and_item_names',
      '/api/v1/items/intersect_item_variants',
      '/promo/v1/payments',
      '/promo/v1/payments',
      '/promo/v1/payments/\\d+',
      '/promo/v1/reports/category',
      '/promo/v1/reports/discount',
      '/promo/v1/reports/item',
      '/promo/v1/types',
      '/promo/v1/promos/\\d+',
    ],
    sub_menu: 'Promo',
    sub_menu_name: 'Promos',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 13,
    priority_rank: 130,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/library/sales_type',
      '/library/v1/sales-type',
      '/library/v1/sales-type/\\d+',
      '/library/v1/sales-type',
      '/library/v1/sales-type/all-outlet',
      '/library/v1/sales-type/\\d+',
      '/library/v1/sales-type/manage-state/\\d+',
      '/library/v1/sales-type/\\d+',
      '/library/v1/sales-type/check-deletable/\\d+',
    ],
    sub_menu: 'Sales Type',
    sub_menu_name: 'Sales Types',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 28,
    priority_rank: 280,
    menu: 'Table Management',
    menu_name: 'Manage Table Management',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/table-management/group',
      '/table-management/v1/table-groups',
      '/table-management/v1/table-groups',
      '/table-management/v1/table-groups/\\d+',
      '/table-management/v1/table-groups/\\d+',
      '/table-management/v1/table-groups/\\d+',
      '/table-management/v1/table-groups/\\d+',
    ],
    sub_menu: 'Table Group',
    sub_menu_name: 'Table Groups',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 29,
    priority_rank: 290,
    menu: 'Table Management',
    menu_name: 'Manage Table Management',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/table-management/map',
      '/table-management/v1/table-groups/\\d+/tables',
      '/table-management/v1/table-groups/\\d+/tables',
      '/table-management/v1/table-groups/\\d+/tables/\\d+',
    ],
    sub_menu: 'Table Map',
    sub_menu_name: 'Table Map',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 30,
    priority_rank: 300,
    menu: 'Table Management',
    menu_name: 'Manage Table Management',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: [
      '/table-management/report',
      '/sync-bill/v1/bills/outlet/\\d+',
      '/sync-bill/v1/bills/outlet/\\d+/bill/\\d+',
      '/sync-bill/v1/bills/outlet/\\d+/summary',
      '/table-management/void-item-report',
    ],
    sub_menu: 'Table Report',
    sub_menu_name: 'Table Reports',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 50,
    priority_rank: 410,
    menu: 'Payments',
    menu_name: 'Payments',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/payments/payment_methods'],
    sub_menu: 'Mobile Payments',
    sub_menu_name: 'Mobile Payments',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 51,
    priority_rank: 305,
    menu: 'Partner Solutions',
    menu_name: 'Apps',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/apps/app-market', '/apps/my-app'],
    sub_menu: 'Apps',
    sub_menu_name: 'Apps',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 53,
    priority_rank: 307,
    menu: 'Capital',
    menu_name: 'Capital',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: [
      '/capital',
      '/capital/v1/administrations/\\w+/updates',
      '/capital/v1/consents',
      '/capital/v1/consents',
      '/capital/v1/documents/\\d+/views',
      '/capital/v1/finalapprovals',
      '/capital/v1/finalapprovals/uploads',
      '/capital/v1/preapprovals',
      '/capital/v1/preapprovals',
      '/capital/v1/submissions',
      '/capital/v1/loan-eligibilities',
      '/capital/v1/submissions',
      '/capital/v1/finalapprovals',
      '/capital/term-loan',
      '/capital/fast-loan',
      '/capital/term-loan/conditions',
      '/capital/fast-loan/conditions',
      '/capital/fast-loan/status',
      '/capital/fast-loan/tenor',
    ],
    sub_menu: 'Capital',
    sub_menu_name: 'Capital',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 54,
    priority_rank: 533,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/settings/bank_account'],
    sub_menu: 'Bank Account',
    sub_menu_name: 'Bank Account',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 71,
    priority_rank: 420,
    menu: 'Payments',
    menu_name: 'Payments',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/payments/payment_configuration'],
    sub_menu: 'Payment Configuration',
    sub_menu_name: 'Payment Configuration',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 105,
    priority_rank: 272,
    menu: 'Customer Display',
    menu_name: 'Manage Customer Display',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/customer-display/settings'],
    sub_menu: 'Settings',
    sub_menu_name: 'Settings',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 90,
    priority_rank: 271,
    menu: 'Customer Display',
    menu_name: 'Manage Customer Display',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/customer-display/campaign'],
    sub_menu: 'Campaign',
    sub_menu_name: 'Campaign',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 72,
    priority_rank: 131,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/library/brands'],
    sub_menu: 'Brands',
    sub_menu_name: 'Brands',
    is_allowed_for_moka_pay: false,
  },
  {
    id: 73,
    priority_rank: 211,
    menu: 'Online Channels',
    menu_name: 'Online Channels',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/online-store/gostore'],
    sub_menu: 'Moka Order',
    sub_menu_name: 'Moka Order',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 74,
    priority_rank: 212,
    menu: 'Online Channels',
    menu_name: 'Online Channels',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/online-store/facebook-instagram-shop'],
    sub_menu: 'Facebook & Instagram Shop',
    sub_menu_name: 'Facebook & Instagram Shop',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 75,
    priority_rank: 213,
    menu: 'Online Channels',
    menu_name: 'Online Channels',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/online-store/google-shopping'],
    sub_menu: 'Google Shopping',
    sub_menu_name: 'Google Shopping',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 77,
    priority_rank: 85,
    menu: 'Library',
    menu_name: 'Manage Library',
    access: 'Back-office',
    level: 3,
    pin_required: false,
    mobile_supported: false,
    usable: true,
    urls: ['/library/bundle-package'],
    sub_menu: 'Bundle Package',
    sub_menu_name: 'Bundle Package',
    is_allowed_for_moka_pay: false,
    withRedDot: true,
  },
  {
    id: 87,
    priority_rank: 570,
    menu: 'Account Settings',
    menu_name: 'Manage Account Settings',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/settings/inventory'],
    sub_menu: 'Inventory',
    sub_menu_name: 'Inventory',
    is_allowed_for_moka_pay: true,
  },
  {
    id: 89,
    priority_rank: 215,
    menu: 'Online Channels',
    menu_name: 'Online Channels',
    access: 'Back-office',
    level: 1,
    pin_required: false,
    mobile_supported: false,
    usable: false,
    urls: ['/online-store/gofood'],
    sub_menu: 'GoFood',
    sub_menu_name: 'GoFood',
    is_allowed_for_moka_pay: true,
  },
];

const profileMultiOutletData: ProfileModel.Response = {
  business: {
    id: 19847,
    name: 'Mingky Momo',
    address: 'Jl. Popoyo',
    suite: null,
    city: 'Kab. Gunung Kidul',
    province: 'DI Yogyakarta',
    postal_code: '55891',
    description: 'dgfb',
    email: 'dimas.nugraha@mokapos.com',
    phone: '082213256987',
    logo: {
      url: 'https://file-public-staging.s3.ap-southeast-1.amazonaws.com/business-service/19847/screenshot-2022-08-10-at-10-49-04-am-495fa555.png',
    },
    notify_per_deposit: null,
    notify_per_trans: null,
    user_id: 33685,
    is_deleted: false,
    created_at: '2019-04-10 18:04:42.449+0700',
    updated_at: '2022-09-06 10:39:03.092+0700',
    business_type_id: 3,
    business_category_id: 15,
    website: 'dfgf',
    twitter: 'gfghg',
    facebook: 'fghfh',
    instagram: 'fhgfh',
    notes: '',
    latitude: null,
    longitude: null,
    outlet_slot: 9,
    is_trial: false,
    current_plan: 12,
    synchronized_at: '2022-08-10 16:32:43.985+0700',
    last_payment_date: '2021-09-16 16:45:25.975+0700',
    trial_end_at: '2019-10-15 00:00:00.000+0700',
    is_enterprise: false,
    is_registration_complete: true,
    start_year: 2012,
    revenue: '5-10 million IDR',
    is_kyb_registration_completed: false,
    kyb_status: 'pending',
    business_entity_type: 'corporate',
    referral_code: null,
    kecamatan: 'Karangmojo',
    setting: {
      id: 19845,
      enable_tax: false,
      customer_sign_on_ipad: false,
      enable_gratuity: false,
      logo_on_receipt: false,
      business_id: 19847,
      is_deleted: false,
      created_at: '2019-04-10 11:04:42.453+0000',
      updated_at: '2023-02-05 20:13:41.099+0000',
      include_gratuity_tax: false,
      start_filtered_date: '2023-02-04 17:00:00.000+0000',
      end_filtered_date: '2023-02-05 16:59:59.999+0000',
      allow_staff_refund: false,
      auth_code: '',
      daily_sales_summary: true,
      product_updates: true,
      inventory_alerts: true,
      customer_feedback: true,
      track_server: false,
      staff_delete_bill: false,
      synchronized_at: '2023-02-05 20:13:41.098+0000',
      staff_resend_receipt: false,
      promo_update_notif: true,
      setting_alert_recipients: [
        {
          id: 20233,
          setting_id: 19845,
          email: 'staginginv02@gmail.com',
          created_at: '2019-04-10 11:04:42.520+0000',
          updated_at: '2019-04-10 11:04:42.520+0000',
          is_deleted: false,
          verified: true,
          token_expired: '2019-04-11 11:04:42.519+0000',
        },
      ],
      enable_rounding: true,
      is_stock_limit: true,
      is_override_stock_limit: true,
    },
    is_leads: false,
    expired_at: '2030-07-19 00:00:00.000+0700',
    is_mokapay_user: false,
    is_mokapos_user: true,
    has_expired: false,
  },
  outlets: [
    {
      id: 610355,
      business_id: 19847,
      name: 'aoeaoeaoe',
      address: 'Villa Taman Kartini, Jl. Graha Elok VI, Blok H4/2',
      phone_number: '0123123123123',
      city: 'Kota Bekasi',
      province: 'Jawa Barat',
      postal_code: '17113',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:33:03.683+07:00',
      updated_at: '2022-09-06T10:39:33.831+07:00',
      synchronized_at: '2022-08-10T12:33:03.597+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610354,
      business_id: 19847,
      name: 'eter',
      address: 'etret',
      phone_number: '0824359435',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42252',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:14:19.897+07:00',
      updated_at: '2022-08-10T12:19:38.085+07:00',
      synchronized_at: '2022-08-10T12:14:19.787+07:00',
      importing: false,
      exporting: false,
      notes: 'dbfdbgb',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610357,
      business_id: 19847,
      name: 'fgtth',
      address: 'tjy',
      phone_number: '05654765756',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42282',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:16:16.654+07:00',
      updated_at: '2022-08-10T16:16:16.654+07:00',
      synchronized_at: '2022-08-10T16:16:16.481+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610353,
      business_id: 19847,
      name: 'greg-test',
      address: 'rhtr',
      phone_number: '0814890358308',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42274',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:10:26.125+07:00',
      updated_at: '2022-08-10T12:10:26.125+07:00',
      synchronized_at: '2022-08-10T12:10:26.061+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-24T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 30624,
      business_id: 19847,
      name: 'Outlet 1',
      address: 'Jl. Popoyo',
      phone_number: '082213256987',
      city: 'Patrik',
      province: 'Krab',
      postal_code: '12369',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2019-04-10T18:04:42.529+07:00',
      updated_at: '2021-09-16T16:45:25.174+07:00',
      synchronized_at: '2021-09-16T16:45:25.173+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-16T16:45:25.173+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 30793,
      business_id: 19847,
      name: 'Outlet 2',
      address: '-',
      phone_number: '08327736243',
      city: '-',
      province: '-',
      postal_code: '12332',
      latitude: 33.748143,
      longitude: -117.791104,
      is_deleted: false,
      created_at: '2019-04-15T15:11:37.313+07:00',
      updated_at: '2021-09-16T16:45:25.181+07:00',
      synchronized_at: '2021-09-16T16:45:25.181+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-16T16:45:25.18+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 613671,
      business_id: 19847,
      name: 'Outlet 3',
      address: 'Jakarta',
      phone_number: '081287122912',
      city: 'Kota Batam',
      province: 'Kepulauan Riau',
      postal_code: '29452',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-02-23T09:27:50.746+07:00',
      updated_at: '2023-02-23T09:28:11.331+07:00',
      synchronized_at: '2023-02-23T09:27:50.741+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-24T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 613672,
      business_id: 19847,
      name: 'Outlet 4',
      address: 'Jakarta',
      phone_number: '012131312',
      city: 'Kab. Buleleng',
      province: 'Bali',
      postal_code: '81152',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-02-23T09:28:31.31+07:00',
      updated_at: '2023-02-23T09:28:31.31+07:00',
      synchronized_at: '2023-02-23T09:28:31.307+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 613673,
      business_id: 19847,
      name: 'Outlet 5',
      address: 'Kakarta',
      phone_number: '01232312312',
      city: 'Kab. Badung',
      province: 'Bali',
      postal_code: '80361',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-02-23T09:28:52.903+07:00',
      updated_at: '2023-02-23T09:28:52.903+07:00',
      synchronized_at: '2023-02-23T09:28:52.901+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610358,
      business_id: 19847,
      name: 'rgth',
      address: 'tyhy',
      phone_number: '04565768768',
      city: 'Kab. Bangli',
      province: 'Bali',
      postal_code: '80612',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:27:39.207+07:00',
      updated_at: '2022-08-10T16:27:39.207+07:00',
      synchronized_at: '2022-08-10T16:27:39.079+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610359,
      business_id: 19847,
      name: 'sdfsdf',
      address: 'sdfsdf',
      phone_number: '042342424',
      city: 'Kab. Lebak',
      province: 'Banten',
      postal_code: '42318',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:31:09.105+07:00',
      updated_at: '2022-08-10T16:31:09.105+07:00',
      synchronized_at: '2022-08-10T16:31:09.046+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 614217,
      business_id: 33260,
      name: 'Outlet 8',
      address: 'awdadwa',
      phone_number: '081287122912',
      city: 'Kab. Bangka Selatan',
      province: 'Kepulauan Bangka Belitung',
      postal_code: '33791',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-03-02T15:07:50.189+07:00',
      updated_at: '2023-03-02T15:07:50.189+07:00',
      synchronized_at: '2023-03-02T15:07:50.085+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T00:00:00+07:00',
      end_date: '2024-03-16T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 614218,
      business_id: 33260,
      name: 'Outlet 9',
      address: 'awdaw',
      phone_number: '081287122912',
      city: 'Kab. Dogiyai',
      province: 'Papua Tengah',
      postal_code: '98862',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-03-02T15:08:10.648+07:00',
      updated_at: '2023-03-02T15:08:10.648+07:00',
      synchronized_at: '2023-03-02T15:08:10.586+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T00:00:00+07:00',
      end_date: '2024-03-16T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  id: 33685,
  email: 'staginginv02@gmail.com',
  first_name: 'Vien',
  last_name: 'Aulia',
  remember_token: 'a58746ef894746ef985f79efb024e600ef2d7868',
  security_question: null,
  security_question_answer: null,
  is_deleted: false,
  is_owner: true,
  is_confirmed: true,
  phone: '082213256987',
  import_items_file: null,
  import_inventory_file: null,
  referral_id: null,
  import_incoming_file: null,
  import_customers_file: null,
  is_manager: false,
  import_adjustment_file: null,
  export_items_file: null,
  importing: false,
  exporting: false,
  import_suppliers_file: null,
  forgot_password_expired_at: null,
  synchronized_at: '2023-02-07 06:34:38.248+0000',
  created_at: '2019-04-10 11:04:41.974+0000',
  expired_at: '2030-07-19 00:00:00.000+0700',
  updated_at: '2022-12-05 01:58:32.906+0000',
  reset_password_token: null,
  reset_password_sent_at: null,
  remember_created_at: null,
  sign_in_count: 0,
  current_sign_in_at: null,
  last_sign_in_at: '2023-02-07 06:34:38.227+0000',
  current_sign_in_ip: null,
  last_sign_in_ip: null,
  current_inventory_dropdown: 'items',
  description: '',
  auth_code: '',
  test_account: false,
  outlet_id: [610355, 610354, 610357, 610353, 30624, 30793, 610358, 610359],
  photo_url: '',
  slot_id: null,
  ktp_number: null,
  ktp_name: null,
  npwp_number: null,
  gravatar:
    'https://file-public-staging.s3.ap-southeast-1.amazonaws.com/business-service/19847/screenshot-2022-08-10-at-10-49-04-am-495fa555.png',
  selected_outlets: [
    {
      id: 610355,
      business_id: 19847,
      name: 'aoeaoeaoe',
      address: 'Villa Taman Kartini, Jl. Graha Elok VI, Blok H4/2',
      phone_number: '0123123123123',
      city: 'Kota Bekasi',
      province: 'Jawa Barat',
      postal_code: '17113',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:33:03.683+07:00',
      updated_at: '2022-09-06T10:39:33.831+07:00',
      synchronized_at: '2022-08-10T12:33:03.597+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610354,
      business_id: 19847,
      name: 'eter',
      address: 'etret',
      phone_number: '0824359435',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42252',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:14:19.897+07:00',
      updated_at: '2022-08-10T12:19:38.085+07:00',
      synchronized_at: '2022-08-10T12:14:19.787+07:00',
      importing: false,
      exporting: false,
      notes: 'dbfdbgb',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610357,
      business_id: 19847,
      name: 'fgtth',
      address: 'tjy',
      phone_number: '05654765756',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42282',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:16:16.654+07:00',
      updated_at: '2022-08-10T16:16:16.654+07:00',
      synchronized_at: '2022-08-10T16:16:16.481+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610353,
      business_id: 19847,
      name: 'greg-test',
      address: 'rhtr',
      phone_number: '0814890358308',
      city: 'Kab. Pandeglang',
      province: 'Banten',
      postal_code: '42274',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T12:10:26.125+07:00',
      updated_at: '2022-08-10T12:10:26.125+07:00',
      synchronized_at: '2022-08-10T12:10:26.061+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-24T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 30624,
      business_id: 19847,
      name: 'Outlet 1',
      address: 'Jl. Popoyo',
      phone_number: '082213256987',
      city: 'Patrik',
      province: 'Krab',
      postal_code: '12369',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2019-04-10T18:04:42.529+07:00',
      updated_at: '2021-09-16T16:45:25.174+07:00',
      synchronized_at: '2021-09-16T16:45:25.173+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-16T16:45:25.173+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 30793,
      business_id: 19847,
      name: 'Outlet 2',
      address: '-',
      phone_number: '08327736243',
      city: '-',
      province: '-',
      postal_code: '12332',
      latitude: 33.748143,
      longitude: -117.791104,
      is_deleted: false,
      created_at: '2019-04-15T15:11:37.313+07:00',
      updated_at: '2021-09-16T16:45:25.181+07:00',
      synchronized_at: '2021-09-16T16:45:25.181+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-16T16:45:25.18+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610358,
      business_id: 19847,
      name: 'rgth',
      address: 'tyhy',
      phone_number: '04565768768',
      city: 'Kab. Bangli',
      province: 'Bali',
      postal_code: '80612',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:27:39.207+07:00',
      updated_at: '2022-08-10T16:27:39.207+07:00',
      synchronized_at: '2022-08-10T16:27:39.079+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 610359,
      business_id: 19847,
      name: 'sdfsdf',
      address: 'sdfsdf',
      phone_number: '042342424',
      city: 'Kab. Lebak',
      province: 'Banten',
      postal_code: '42318',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2022-08-10T16:31:09.105+07:00',
      updated_at: '2022-08-10T16:31:09.105+07:00',
      synchronized_at: '2022-08-10T16:31:09.046+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2022-08-10T00:00:00+07:00',
      end_date: '2023-07-19T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  user_outlets_id: [610355, 610354, 610357, 610353, 30624, 30793, 610358, 610359, 614218],
  already_subscribed: true,
  ingredient_subscription: true,
  loyalty_subscription: true,
  full_name: null,
  is_phone_number_verified: false,
  role_id: 1,
  role_name: 'Owner',
  permissions: defaultPermissions,
  uniq_id: null,
  receipt_counter: 0,
  invoice_counter: 0,
  feature_subscription: [],
  hermes: null,
  has_saudagar_outlet: false,
};

const profileSingleOutletData: ProfileModel.Response = {
  business: {
    id: 33258,
    name: '',
    address: '',
    suite: null,
    city: 'Kota Jakarta Selatan',
    province: 'DKI Jakarta',
    postal_code: '',
    description: '',
    email: '',
    phone: '+6283876718750',
    logo: null,
    notify_per_deposit: null,
    notify_per_trans: null,
    user_id: 122335,
    is_deleted: false,
    created_at: '2023-03-02 11:39:16.503+0700',
    updated_at: '2023-03-02 11:39:37.052+0700',
    business_type_id: 3,
    business_category_id: 19,
    website: '',
    twitter: '',
    facebook: '',
    instagram: '',
    notes: '',
    latitude: null,
    longitude: undefined,
    outlet_slot: 1,
    is_trial: true,
    current_plan: 1,
    synchronized_at: '2023-03-02 11:39:16.500+0700',
    last_payment_date: '',
    trial_end_at: '2023-03-16 07:00:00.000+0700',
    is_enterprise: false,
    is_registration_complete: false,
    start_year: 2000,
    revenue: '',
    is_kyb_registration_completed: false,
    kyb_status: 'pending',
    business_entity_type: '',
    referral_code: '',
    kecamatan: '',
    setting: {
      id: 33259,
      enable_tax: false,
      customer_sign_on_ipad: false,
      enable_gratuity: false,
      logo_on_receipt: false,
      business_id: 33258,
      is_deleted: false,
      created_at: '2023-03-02 04:39:16.505+0000',
      updated_at: '2023-03-02 04:39:16.505+0000',
      include_gratuity_tax: false,
      start_filtered_date: '',
      end_filtered_date: '',
      allow_staff_refund: false,
      auth_code: '',
      daily_sales_summary: true,
      product_updates: true,
      inventory_alerts: true,
      customer_feedback: true,
      track_server: false,
      staff_delete_bill: false,
      synchronized_at: '',
      staff_resend_receipt: false,
      promo_update_notif: true,
      setting_alert_recipients: [
        {
          id: 39096,
          setting_id: 33259,
          email: '',
          created_at: '2023-03-02 04:39:16.507+0000',
          updated_at: '2023-03-02 04:39:16.507+0000',
          is_deleted: false,
          verified: true,
          token_expired: '2023-03-03 04:39:16.500+0000',
        },
      ],
      enable_rounding: false,
      is_stock_limit: false,
      is_override_stock_limit: false,
    },
    is_leads: false,
    expired_at: '2030-03-16 07:00:00.000+0700',
    is_mokapay_user: false,
    is_mokapos_user: true,
    has_expired: false,
  },
  outlets: [
    {
      id: 614207,
      business_id: 33258,
      name: 'Outlet 1',
      address: '',
      phone_number: '+6283876718750',
      city: '',
      province: '',
      postal_code: '',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-03-02T11:39:16.511+07:00',
      updated_at: '2023-03-02T11:39:16.511+07:00',
      synchronized_at: '2023-03-02T11:39:16.5+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T11:39:16.5+07:00',
      end_date: '2023-03-16T07:00:00+07:00',
      is_paying: false,
      saudagar: undefined,
    },
  ],
  id: 122335,
  email: 'proeng-fe+01@mailinator.com',
  first_name: 'proeng-fe+01',
  last_name: ' ',
  remember_token: '',
  security_question: null,
  security_question_answer: null,
  is_deleted: false,
  is_owner: true,
  is_confirmed: true,
  phone: '+6283876718750--2023-03-02044856765',
  import_items_file: null,
  import_inventory_file: null,
  referral_id: null,
  import_incoming_file: null,
  import_customers_file: null,
  is_manager: false,
  import_adjustment_file: null,
  export_items_file: null,
  importing: false,
  exporting: false,
  import_suppliers_file: null,
  forgot_password_expired_at: null,
  synchronized_at: '2023-03-02 06:30:27.045+0000',
  created_at: '2023-03-02 04:39:16.477+0000',
  expired_at: '2030-03-16 07:00:00.000+0700',
  updated_at: '2023-03-02 04:39:16.477+0000',
  reset_password_token: null,
  reset_password_sent_at: null,
  remember_created_at: null,
  sign_in_count: 0,
  current_sign_in_at: null,
  last_sign_in_at: '2023-03-02 06:30:27.030+0000',
  current_sign_in_ip: null,
  last_sign_in_ip: null,
  current_inventory_dropdown: 'item',
  description: '',
  auth_code: '',
  test_account: true,
  outlet_id: [614207],
  photo_url: '',
  slot_id: null,
  ktp_number: null,
  ktp_name: null,
  npwp_number: null,
  gravatar: '',
  selected_outlets: [
    {
      id: 614207,
      business_id: 33258,
      name: 'Outlet 1',
      address: '',
      phone_number: '+6283876718750',
      city: '',
      province: '',
      postal_code: '',
      latitude: null,
      longitude: undefined,
      is_deleted: false,
      created_at: '2023-03-02T11:39:16.511+07:00',
      updated_at: '2023-03-02T11:39:16.511+07:00',
      synchronized_at: '2023-03-02T11:39:16.5+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T11:39:16.5+07:00',
      end_date: '2023-03-16T07:00:00+07:00',
      is_paying: false,
      saudagar: undefined,
    },
  ],
  user_outlets_id: [614207],
  already_subscribed: false,
  ingredient_subscription: false,
  loyalty_subscription: false,
  full_name: 'proeng-fe+01  ',
  is_phone_number_verified: true,
  role_id: 1,
  role_name: 'Owner',
  permissions: defaultPermissions,
  uniq_id: null,
  receipt_counter: null,
  invoice_counter: null,
  feature_subscription: [],
  hermes: null,
  has_saudagar_outlet: false,
};

const profileTwoOutletData: ProfileModel.Response = {
  business: {
    id: 205,
    name: 'LCoffee ',
    address: 'Jl. Kemakmuran Utara',
    suite: '',
    city: 'Jakarta',
    province: 'Indonesia',
    postal_code: '17056',
    description: 'Come and taste our coffee',
    email: 'Ariya.done@mailinator.com',
    phone: '08909989',
    logo: { url: 'https://mokapos-staging.s3.amazonaws.com/uploads/business/logo/205/lggripbottle1155c141209original_1424066984.png' },
    notify_per_deposit: null,
    notify_per_trans: null,
    user_id: 228,
    is_deleted: false,
    created_at: '2015-02-10 13:16:05.483+0700',
    updated_at: '2022-06-16 11:16:24.255+0700',
    business_type_id: 9,
    business_category_id: 66,
    website: '',
    twitter: '',
    facebook: '',
    instagram: '',
    notes: '',
    latitude: -6.165128999999999,
    longitude: 106.816226,
    outlet_slot: 2,
    is_trial: false,
    current_plan: 12,
    synchronized_at: '2017-08-28 17:12:00.329+0700',
    last_payment_date: '',
    trial_end_at: '2019-10-15 00:00:00.000+0700',
    is_enterprise: true,
    is_registration_complete: false,
    start_year: 2000,
    revenue: '',
    is_kyb_registration_completed: false,
    kyb_status: 'pending',
    business_entity_type: '',
    referral_code: null,
    kecamatan: '',
    setting: {
      id: 205,
      enable_tax: true,
      customer_sign_on_ipad: false,
      enable_gratuity: true,
      logo_on_receipt: false,
      business_id: 205,
      is_deleted: false,
      created_at: '2015-02-10 06:16:05.501+0000',
      updated_at: '2016-10-10 02:53:15.822+0000',
      include_gratuity_tax: true,
      start_filtered_date: '2015-03-01 17:00:00.000+0000',
      end_filtered_date: '2015-03-01 17:00:00.000+0000',
      allow_staff_refund: true,
      auth_code: '1234',
      daily_sales_summary: false,
      product_updates: false,
      inventory_alerts: false,
      customer_feedback: true,
      track_server: true,
      staff_delete_bill: false,
      synchronized_at: '2016-10-10 02:53:15.822+0000',
      staff_resend_receipt: false,
      promo_update_notif: true,
      setting_alert_recipients: [
        {
          id: 195,
          setting_id: 205,
          email: 'teguhmoka@mailinator.com',
          created_at: '2015-02-11 07:45:19.148+0000',
          updated_at: '2015-02-11 07:45:19.148+0000',
          is_deleted: false,
          verified: true,
          token_expired: null,
        },
      ],
      enable_rounding: false,
      is_stock_limit: false,
      is_override_stock_limit: false,
    },
    is_leads: null,
    expired_at: '2030-01-01 00:00:00.000+0700',
    is_mokapay_user: false,
    has_expired: false,
    is_mokapos_user: true,
  },
  outlets: [
    {
      id: 123,
      business_id: 205,
      name: 'Default Outlet for LCoffee ',
      address: 'Jl. Kemakmuran Utara',
      phone_number: '08909989',
      city: 'Jakarta',
      province: 'Indonesia',
      postal_code: '17056',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2015-05-18T11:10:33.136+07:00',
      updated_at: '2022-06-16T11:16:25.023+07:00',
      synchronized_at: '2022-06-16T11:15:22.932+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2015-02-10T13:16:05.483+07:00',
      end_date: '2024-01-01T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 435,
      business_id: 205,
      name: 'Outlet 1',
      address: 'Jl. Kemakmuran Utara',
      phone_number: '08909989',
      city: 'Jakarta',
      province: 'Indonesia',
      postal_code: '17056',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2015-06-05T17:55:36.926+07:00',
      updated_at: '2022-06-16T11:16:24.26+07:00',
      synchronized_at: '2015-12-18T09:31:50.224+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2015-02-10T13:16:05.483+07:00',
      end_date: '2024-01-01T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  id: 228,
  email: 'teguhmoka@mailinator.com',
  first_name: 'Teguh',
  last_name: 'Ariya',
  remember_token: '928942f3ed54d3238f6196218259e83aaf99e9b4',
  security_question: null,
  security_question_answer: null,
  is_deleted: false,
  is_owner: true,
  is_confirmed: true,
  phone: '62',
  import_items_file: null,
  import_inventory_file: null,
  referral_id: null,
  import_incoming_file: null,
  import_customers_file: null,
  is_manager: false,
  import_adjustment_file: null,
  export_items_file:
    'https://mokapos-staging.s3.amazonaws.com/uploads/export/2015/December/18/Moka_Export_Items_Template_~_Outlet_1_~_teguhmoka@mailinator.com_3d8b8579.csv',
  importing: false,
  exporting: false,
  import_suppliers_file: null,
  forgot_password_expired_at: null,
  synchronized_at: '2023-05-30 03:18:49.739+0000',
  created_at: '2015-02-10 06:16:05.364+0000',
  expired_at: '2030-01-01 00:00:00.000+0700',
  updated_at: '2022-06-16 04:25:25.873+0000',
  reset_password_token: null,
  reset_password_sent_at: null,
  remember_created_at: null,
  sign_in_count: 0,
  current_sign_in_at: null,
  last_sign_in_at: '2023-05-30 03:18:49.713+0000',
  current_sign_in_ip: null,
  last_sign_in_ip: null,
  current_inventory_dropdown: 'items',
  description: '',
  auth_code: '',
  test_account: null,
  outlet_id: [123, 435],
  photo_url: '',
  slot_id: null,
  ktp_number: null,
  ktp_name: null,
  npwp_number: null,
  gravatar: 'https://mokapos-staging.s3.amazonaws.com/uploads/business/logo/205/lggripbottle1155c141209original_1424066984.png',
  selected_outlets: [
    {
      id: 123,
      business_id: 205,
      name: 'Default Outlet for LCoffee ',
      address: 'Jl. Kemakmuran Utara',
      phone_number: '08909989',
      city: 'Jakarta',
      province: 'Indonesia',
      postal_code: '17056',
      latitude: null,
      longitude: null,
      is_deleted: false,
      created_at: '2015-05-18T11:10:33.136+07:00',
      updated_at: '2022-06-16T11:16:25.023+07:00',
      synchronized_at: '2022-06-16T11:15:22.932+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2015-02-10T13:16:05.483+07:00',
      end_date: '2024-01-01T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 435,
      business_id: 205,
      name: 'Outlet 1',
      address: 'Jl. Kemakmuran Utara',
      phone_number: '08909989',
      city: 'Jakarta',
      province: 'Indonesia',
      postal_code: '17056',
      latitude: null,
      longitude: null,
      is_deleted: false,
      created_at: '2015-06-05T17:55:36.926+07:00',
      updated_at: '2022-06-16T11:16:24.26+07:00',
      synchronized_at: '2015-12-18T09:31:50.224+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2015-02-10T13:16:05.483+07:00',
      end_date: '2024-01-01T00:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  user_outlets_id: [123, 435],
  already_subscribed: true,
  ingredient_subscription: false,
  loyalty_subscription: false,
  full_name: null,
  is_phone_number_verified: false,
  role_id: 1,
  role_name: 'Owner',
  permissions: defaultPermissions,
  uniq_id: null,
  receipt_counter: null,
  invoice_counter: null,
  feature_subscription: [],
  hermes: null,
  has_saudagar_outlet: false,
};

const profileThreeOutletData: ProfileModel.Response = {
  business: {
    id: 21683,
    name: 'proengSEIT1.1',
    address: 'jalan asik',
    suite: null,
    city: 'Kota Jakarta Selatan',
    province: 'DKI Jakarta',
    postal_code: '12120',
    description: '',
    email: '',
    phone: '+6281213334852',
    logo: null,
    notify_per_deposit: null,
    notify_per_trans: null,
    user_id: 96954,
    is_deleted: false,
    created_at: '2021-06-21 16:45:02.185+0700',
    updated_at: '2023-10-25 17:08:55.918+0700',
    business_type_id: 8,
    business_category_id: 67,
    website: '',
    twitter: '',
    facebook: '',
    instagram: '',
    notes: '',
    latitude: -6.2447132,
    longitude: 106.8006951,
    outlet_slot: 3,
    is_trial: false,
    current_plan: 12,
    synchronized_at: '2023-10-25 17:08:55.890+0700',
    last_payment_date: '2023-10-24 12:18:38.972+0700',
    trial_end_at: '2021-09-19 00:00:00.000+0700',
    is_enterprise: false,
    is_registration_complete: false,
    start_year: 2000,
    revenue: '',
    is_kyb_registration_completed: true,
    kyb_status: 'pending',
    business_entity_type: 'personal',
    referral_code: null,
    kecamatan: 'Kebayoran Baru',
    setting: {
      id: 21681,
      enable_tax: false,
      customer_sign_on_ipad: false,
      enable_gratuity: false,
      logo_on_receipt: false,
      business_id: 21683,
      is_deleted: false,
      created_at: '2021-06-21 09:45:02.191+0000',
      updated_at: '2022-10-06 01:08:42.579+0000',
      include_gratuity_tax: false,
      start_filtered_date: '2021-12-31 16:00:00.000+0000',
      end_filtered_date: '2022-10-06 01:08:42.000+0000',
      allow_staff_refund: false,
      auth_code: '',
      daily_sales_summary: true,
      product_updates: true,
      inventory_alerts: true,
      customer_feedback: true,
      track_server: false,
      staff_delete_bill: false,
      synchronized_at: '2022-10-06 01:08:42.578+0000',
      staff_resend_receipt: false,
      promo_update_notif: true,
      setting_alert_recipients: [
        {
          id: 22789,
          setting_id: 21681,
          email: 'proeng1@mailinator.com',
          created_at: '2021-06-21 09:45:02.215+0000',
          updated_at: '2021-06-21 09:45:02.215+0000',
          is_deleted: false,
          verified: true,
          token_expired: '2021-06-22 09:45:02.213+0000',
        },
      ],
      enable_rounding: false,
      is_stock_limit: false,
      is_override_stock_limit: false,
    },
    is_leads: false,
    expired_at: '2026-03-02 07:00:00.000+0700',
    is_mokapay_user: false,
    is_mokapos_user: true,
    has_expired: false,
  },
  outlets: [
    {
      id: 588959,
      business_id: 21683,
      name: 'Outlet 1.1 2 3 4 5',
      address: 'jalan asik1',
      phone_number: '081213334852',
      city: 'Kota Jakarta Selatan',
      province: 'DKI Jakarta',
      postal_code: '12120',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2021-06-21T16:45:02.272+07:00',
      updated_at: '2023-10-03T12:31:02.782+07:00',
      synchronized_at: '2023-10-03T12:31:02.781+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T10:50:36.895+07:00',
      end_date: '2026-03-02T07:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 601187,
      business_id: 21683,
      name: 'Outlet 2',
      address: 'jalan okeoke',
      phone_number: '0812494494984',
      city: 'Kota Jakarta Pusat',
      province: 'DKI Jakarta',
      postal_code: '10540',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2021-09-29T16:22:00.818+07:00',
      updated_at: '2021-09-29T16:22:00.818+07:00',
      synchronized_at: '2021-09-29T16:22:00.725+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-09-29T00:00:00+07:00',
      end_date: '2026-03-02T07:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
    {
      id: 601218,
      business_id: 21683,
      name: 'Outlet 3',
      address: 'jalan hehehe',
      phone_number: '0812378378378',
      city: 'Kota Jakarta Pusat',
      province: 'DKI Jakarta',
      postal_code: '10530',
      latitude: undefined,
      longitude: undefined,
      is_deleted: false,
      created_at: '2021-10-05T13:26:00.016+07:00',
      updated_at: '2021-10-05T13:26:00.016+07:00',
      synchronized_at: '2021-10-05T13:25:59.922+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2021-10-05T00:00:00+07:00',
      end_date: '2026-03-02T07:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  id: 96954,
  email: 'proeng1@mailinator.com',
  first_name: 'proengseit1.1',
  last_name: '',
  remember_token: '',
  security_question: null,
  security_question_answer: null,
  is_deleted: false,
  is_owner: true,
  is_confirmed: true,
  phone: '+628121333483',
  import_items_file: null,
  import_inventory_file: null,
  referral_id: null,
  import_incoming_file: null,
  import_customers_file: null,
  is_manager: false,
  import_adjustment_file: null,
  export_items_file: null,
  importing: false,
  exporting: false,
  import_suppliers_file: null,
  forgot_password_expired_at: null,
  synchronized_at: '2023-12-18 08:43:54.630+0000',
  created_at: '2021-06-21 09:45:02.161+0000',
  expired_at: '2026-03-02 07:00:00.000+0700',
  updated_at: '2023-03-02 03:49:39.285+0000',
  reset_password_token: null,
  reset_password_sent_at: null,
  remember_created_at: null,
  sign_in_count: 0,
  current_sign_in_at: null,
  last_sign_in_at: '2023-12-18 08:43:54.600+0000',
  current_sign_in_ip: null,
  last_sign_in_ip: null,
  current_inventory_dropdown: 'item',
  description: '',
  auth_code: '',
  test_account: true,
  outlet_id: [588959],
  photo_url: '',
  slot_id: null,
  ktp_number: null,
  ktp_name: null,
  npwp_number: null,
  gravatar: '',
  selected_outlets: [
    {
      id: 588959,
      business_id: 21683,
      name: 'Outlet 1.1 2 3 4 5',
      address: 'jalan asik1',
      phone_number: '081213334852',
      city: 'Kota Jakarta Selatan',
      province: 'DKI Jakarta',
      postal_code: '12120',
      latitude: null,
      longitude: null,
      is_deleted: false,
      created_at: '2021-06-21T16:45:02.272+07:00',
      updated_at: '2023-10-03T12:31:02.782+07:00',
      synchronized_at: '2023-10-03T12:31:02.781+07:00',
      importing: false,
      exporting: false,
      notes: '',
      start_date: '2023-03-02T10:50:36.895+07:00',
      end_date: '2026-03-02T07:00:00+07:00',
      is_paying: true,
      saudagar: undefined,
    },
  ],
  user_outlets_id: [588959, 601187, 601218],
  already_subscribed: true,
  ingredient_subscription: false,
  loyalty_subscription: false,
  full_name: 'proengseit1 ',
  is_phone_number_verified: true,
  role_id: 1,
  role_name: 'Owner',
  permissions: [
    {
      id: 1,
      priority_rank: 10,
      menu: 'Dashboard',
      menu_name: 'View Dashboard',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [
        '/dashboard',
        '/api/v1/dashboard',
        '/reporting/v1/dashboard/lists',
        '/sync-bill/v1/bills/stats',
        '/reporting/v1/dashboard/sales_summary',
        '/reporting/v1/dashboard/item_summary',
      ],
      sub_menu: 'Dashboard',
      sub_menu_name: 'View Dashboard',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 2,
      priority_rank: 20,
      menu: 'Reports',
      menu_name: 'View Reports',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [
        '/reports/sales/summary',
        '/reports/sales/gross_profit',
        '/reports/sales/payment_methods',
        '/reports/sales/item_sales',
        '/reports/sales/category_sales',
        '/reports/sales/modifier_sales',
        '/reports/sales/discounts',
        '/reports/sales/taxes',
        '/reports/sales/gratuity',
        '/reports/sales/staff',
        '/reports/sales/server',
        '/api/v1/reports/category_sales',
        '/api/v1/reports/discounts',
        '/api/v1/reports/export_category_sales',
        '/api/v1/reports/export_discounts',
        '/api/v1/reports/export_gratuities',
        '/api/v1/reports/export_gross_profit',
        '/api/v1/reports/export_item_sales',
        '/api/v1/reports/export_modifiers',
        '/api/v1/reports/export_payment_methods',
        '/api/v1/reports/export_sales_summary',
        '/api/v1/reports/export_servers',
        '/api/v1/reports/export_staff_report',
        '/api/v1/reports/export_taxes',
        '/api/v1/reports/gratuities',
        '/api/v1/reports/gross_profit',
        '/api/v1/reports/modifiers',
        '/api/v1/reports/payment_methods',
        '/api/v1/reports/sales_summary',
        '/api/v1/reports/servers',
        '/api/v1/reports/staff_report',
        '/api/v1/reports/taxes',
        '/api/v2/reports/item_sales',
        '/reports/sales/sales_type',
        '/api/v1/reports/sales_type',
        '/api/v1/reports/export_sales_type',
        '/report/v1/discounts/export',
        '/report/v1/discounts',
        '/reporting/v1/reports/sales_summary',
        '/reporting/v1/reports/gross_profit',
        '/reporting/v1/reports/export_sales_summary',
        '/reporting/v1/reports/export_gross_profit',
        '/reporting/v1/reports/item_sales',
        '/reporting/v1/reports/export_item_sales',
        '/reporting/v1/reports/category_sales',
        '/reporting/v1/reports/export_category_sales',
        '/reporting/v1/reports/payment_methods',
        '/reporting/v1/reports/export_payment_methods',
        '/reports/sales/hourly_item/sold',
        '/reporting/v1/reports/hourly/item_sold',
        '/reporting/v1/reports/export_item_sold',
        '/reports/sales/hourly_item/amount',
        '/reporting/v1/reports/hourly/item_amount',
        '/reporting/v1/reports/export_item_amount',
      ],
      sub_menu: 'Sales',
      sub_menu_name: 'Sales',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 3,
      priority_rank: 30,
      menu: 'Reports',
      menu_name: 'View Reports',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [
        '/reports/transactions',
        '/api/v1/email_receipt',
        '/api/v1/reports/\\d+/transaction_detail',
        '/api/v1/reports/export_transactions',
        '/api/v1/reports/transactions',
        '/api/v2/refunds',
        '/api/v1/reports/export_by_item',
      ],
      sub_menu: 'Transactions',
      sub_menu_name: 'Transactions',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 4,
      priority_rank: 40,
      menu: 'Reports',
      menu_name: 'View Reports',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [
        '/reports/invoices',
        '/api/v1/invoices/\\d+.json',
        '/api/v1/invoices/\\d+/resend_email',
        '/api/v1/invoices/export',
        '/api/v1/invoices/payment_records',
        '/api/v1/reports/invoices',
        '/api/v2/refunds',
        '/api/v1/invoices/\\d+.pdf',
      ],
      sub_menu: 'Invoices',
      sub_menu_name: 'Invoices',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 5,
      priority_rank: 50,
      menu: 'Reports',
      menu_name: 'View Reports',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [
        '/reports/shifts',
        '/api/v1/cash_drawer/shifts',
        '/api/v1/cash_drawer/shifts/\\d+',
        '/api/v1/cash_drawer/shifts/export',
        '/api/v1/cash_drawer/shifts/summary',
      ],
      sub_menu: 'Shift',
      sub_menu_name: 'Shifts',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 6,
      priority_rank: 60,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/list',
        '/api/v1/categories/with_uncategorized',
        '/api/v1/ingredients/have_recipe',
        '/api/v1/items',
        '/api/v1/items',
        '/api/v1/items/\\d+',
        '/api/v1/items/create_all_outlet',
        '/api/v1/items/import_items',
        '/api/v1/items/import_items_template',
        '/api/v1/items/import_items_temporary',
        '/api/v1/items/new',
        '/api/v1/items/summary',
        '/api/v1/modifiers',
        '/api/v1/s3/new',
        '/api/v1/items/\\d+/update_image',
        '/api/v1/items/\\d+',
        '/api/v1/items/\\d+',
        '/library/v1/sales-type',
        '/loyalty/v2/programs',
        '/library/v1/items',
        '/api/v3/items',
        '/api/v3/items',
        '/api/v3/items',
        '/api/v3/items',
        '/api/v3/items/validate_create_all_outlet',
        '/api/v3/items/create_all_outlet',
        '/api/v3/items/import_items',
        '/api/v3/items/import_items_temporary',
        '/api/v3/items/import_items_template',
        '/api/v3/items/get_modifiers_list',
        '/loyalty/v3/programs',
        '/api/v1/items/\\d+/delete_all_outlet',
      ],
      sub_menu: 'Item Library',
      sub_menu_name: 'Item Library',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 7,
      priority_rank: 70,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/modifier',
        '/api/v1/modifiers',
        '/api/v1/modifiers/\\d+/apply_to_items',
        '/api/v1/modifiers/\\d+/delete_modifier',
        '/api/v1/modifiers/\\d+',
        '/api/v1/modifiers/create_all_outlet',
        '/api/v2/items',
        '/api/v2/modifiers',
        '/library/v1/items',
      ],
      sub_menu: 'Modifiers',
      sub_menu_name: 'Modifiers',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 8,
      priority_rank: 80,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/categories',
        '/api/v1/categories',
        '/api/v1/categories/\\d+',
        '/api/v1/categories/\\d+',
        '/api/v1/categories/\\d+/move_items',
        '/api/v1/categories/\\d+',
        '/api/v1/categories/create_all_outlet',
        '/api/v1/items',
        '/api/v2/categories',
        '/api/v2/items',
        '/api/v1/categories',
        '/loyalty/v2/programs',
        '/library/v1/items',
        '/loyalty/v3/programs',
      ],
      sub_menu: 'Categories',
      sub_menu_name: 'Item Categories',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 10,
      priority_rank: 100,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/discounts',
        '/api/v1/discounts',
        '/api/v1/discounts/\\d+',
        '/api/v1/discounts/\\d+',
        '/api/v1/discounts/create_all_outlet',
        '/api/v2/discounts',
      ],
      sub_menu: 'Discounts',
      sub_menu_name: 'Discounts',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 11,
      priority_rank: 110,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/library/taxes',
        '/api/v1/taxes',
        '/api/v1/taxes/\\d+',
        '/api/v1/taxes/\\d+',
        '/api/v1/taxes/\\d+',
        '/api/v1/taxes/create_all_outlet',
        '/api/v2/taxes',
      ],
      sub_menu: 'Taxes',
      sub_menu_name: 'Taxes',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 12,
      priority_rank: 120,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/library/gratuity',
        '/api/v1/gratuities',
        '/api/v1/gratuities/\\d+',
        '/api/v1/gratuities/\\d+',
        '/api/v1/gratuities/\\d+',
        '/api/v1/gratuities/create_all_outlet',
        '/api/v2/gratuities',
      ],
      sub_menu: 'Gratuity',
      sub_menu_name: 'Gratuity',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 14,
      priority_rank: 140,
      menu: 'Ingredient',
      menu_name: 'Manage Ingredients',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/ingredient/list',
        '/api/v1/ingredient_categories/with_uncategorized',
        '/api/v1/ingredients',
        '/api/v1/ingredients',
        '/api/v1/ingredients/\\d+',
        '/api/v1/ingredients/\\d+',
        '/api/v1/ingredients/create_all_outlet',
        '/api/v1/ingredients/export',
        '/api/v1/ingredients/have_recipe',
        '/api/v1/ingredients/import',
        '/api/v1/ingredients/import_temp',
        '/api/v1/s3/new',
        '/api/v1/units',
      ],
      sub_menu: 'Ingredient Library',
      sub_menu_name: 'Ingredient Library',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 15,
      priority_rank: 150,
      menu: 'Ingredient',
      menu_name: 'Manage Ingredients',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/ingredient/categories',
        '/api/v1/ingredient_categories',
        '/api/v1/ingredient_categories',
        '/api/v1/ingredient_categories/\\d+/assigns',
        '/api/v1/ingredient_categories/\\d+',
        '/api/v1/ingredient_categories/\\d+',
        '/api/v1/ingredient_categories/create_all_outlet',
        '/api/v1/ingredients',
      ],
      sub_menu: 'Ingredient Categories',
      sub_menu_name: 'Ingredient Categories',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 16,
      priority_rank: 160,
      menu: 'Ingredient',
      menu_name: 'Manage Ingredients',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/ingredient/recipes',
        '/api/v1/ingredients',
        '/api/v1/items/item_dropdowns',
        '/api/v1/recipes',
        '/api/v1/recipes',
        '/api/v1/recipes/\\d+',
        '/api/v1/recipes/\\d+/update_all_outlets',
        '/api/v1/recipes/\\d+',
        '/api/v1/recipes/create_all_outlets',
        '/api/v1/recipes/export',
        '/api/v1/recipes/item_variants/\\d+',
      ],
      sub_menu: 'Recipes',
      sub_menu_name: 'Recipes',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 17,
      priority_rank: 170,
      menu: 'Inventory',
      menu_name: 'Manage Inventory',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/inventory/summary',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/inventory/summary',
        '/api/v1/inventory/summary/export',
        '/api/v1/ingredients_inventory/summary',
        '/api/v1/ingredients_inventory/summary/export',
      ],
      sub_menu: 'Summary',
      sub_menu_name: 'Inventory Summary',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 18,
      priority_rank: 180,
      menu: 'Inventory',
      menu_name: 'Manage Inventory',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/inventory/suppliers',
        '/api/v1/inventory/suppliers',
        '/api/v1/inventory/suppliers',
        '/api/v1/inventory/suppliers/\\d+',
        '/api/v1/inventory/suppliers/\\d+',
        '/api/v1/inventory/suppliers/export',
      ],
      sub_menu: 'Suppliers',
      sub_menu_name: 'Suppliers',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 19,
      priority_rank: 190,
      menu: 'Inventory',
      menu_name: 'Manage Inventory',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/inventory/purchase_orders',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/inventory/purchase_orders',
        '/api/v1/inventory/purchase_orders/\\d+.json',
        '/api/v1/inventory/purchase_orders/create_and_fulfilled',
        '/api/v1/inventory/purchase_orders/export',
        '/api/v1/inventory/purchase_orders/search',
        '/api/v1/inventory/suppliers',
        '/api/v1/items',
        '/api/v1/s3/new',
        '/api/v1/inventory/purchase_orders/\\d+',
        '/api/v1/ingredients_inventory/purchase_orders/\\d+',
        '/api/v1/ingredients_inventory/purchase_orders/search',
        '/api/v1/ingredients_inventory/purchase_orders/\\d+.json',
        '/api/v1/ingredients_inventory/purchase_orders/\\d+/edit.json',
        '/api/v1/ingredients/all',
        '/api/v1/ingredients_inventory/purchase_orders',
        '/api/v1/ingredients_inventory/purchase_orders/create_and_fulfilled',
        '/api/v1/ingredients_inventory/purchase_orders/export_template',
        '/api/v1/inventory/purchase_orders/export_template',
        '/api/v1/ingredients_inventory/purchase_orders/import_temporary',
        '/api/v1/ingredients_inventory/purchase_orders/import',
        '/api/v1/ingredients_inventory/purchase_orders/export',
        '/api/v1/inventory/purchase_orders/import_temporary',
        '/api/v1/inventory/purchase_orders/import',
      ],
      sub_menu: 'Purchase Order (PO)',
      sub_menu_name: 'Purchase Orders (PO)',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 20,
      priority_rank: 200,
      menu: 'Inventory',
      menu_name: 'Manage Inventory',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/inventory/transfer',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/inventory/transfer',
        '/api/v1/inventory/transfer',
        '/api/v1/inventory/transfer/export',
        '/api/v1/items',
        '/api/v1/ingredients/all',
        '/api/v1/ingredients_inventory/transfer/export',
        '/api/v1/ingredients_inventory/transfer',
        '/api/v1/ingredients_inventory/transfer',
      ],
      sub_menu: 'Transfer',
      sub_menu_name: 'View Transfer',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 21,
      priority_rank: 210,
      menu: 'Inventory',
      menu_name: 'Manage Inventory',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/inventory/adjustment',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/current_inventory_dropdown',
        '/api/v1/inventory/adjustment',
        '/api/v1/inventory/adjustment',
        '/api/v1/inventory/adjustment/export',
        '/api/v1/inventory/adjustment/import_adjustment_template',
        '/api/v1/inventory/adjustment/import_adjustments',
        '/api/v1/inventory/adjustment/import_adjustments_temporary',
        '/api/v1/items',
        '/api/v1/s3/new',
        '/api/v1/ingredients_inventory/adjustment',
        '/api/v1/ingredients/all',
        '/api/v1/ingredients_inventory/adjustment',
      ],
      sub_menu: 'Adjustment',
      sub_menu_name: 'Adjustments',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 22,
      priority_rank: 220,
      menu: 'Customers',
      menu_name: 'Manage Customers',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/customers/list',
        '/api/v1/customers/import_customers',
        '/api/v1/customers/import_customers_temporary',
        '/api/v1/invoices/\\d+.json',
        '/api/v1/reports/\\d+/transaction_detail',
        '/api/v1/s3/new',
        '/customer/v1/customers',
        '/customer/v1/customers/\\d+',
        '/customer/v1/customers/export',
        '/loyalty/v1/customers/\\d+/point-activities',
        '/loyalty/v1/customers/\\d+/redemptions',
        '/api/v1/invoices/\\d+.pdf',
        '/loyalty/v2/programs',
        '/loyalty/v3/programs',
      ],
      sub_menu: 'Customers List',
      sub_menu_name: 'Customer List',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 23,
      priority_rank: 230,
      menu: 'Customers',
      menu_name: 'Manage Customers',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/customers/feedback_list',
        '/api/v1/customer_feedbacks',
        '/api/v1/customer_feedbacks/\\d+/feedback_messages',
        '/api/v1/customer_feedbacks/submit_reply',
        '/api/v1/reports/\\d+/transaction_detail',
      ],
      sub_menu: 'Feedback',
      sub_menu_name: 'Feedback',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 24,
      priority_rank: 240,
      menu: 'Customers',
      menu_name: 'Manage Customers',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/customers/loyalty',
        '/loyalty/v1/programs',
        '/loyalty/v1/programs',
        '/loyalty/v1/programs',
        '/loyalty/v1/programs/deactivate',
        '/loyalty/v1/programs/reactivate',
        '/loyalty/v1/programs/reset',
        '/loyalty/v2/programs',
        '/loyalty/v2/programs',
        '/loyalty/v2/programs/\\d+',
        '/loyalty/v2/programs/\\d+/deactivate',
        '/loyalty/v2/programs/\\d+/reactivate',
        '/loyalty/v2/programs/\\d+/reset',
        '/loyalty/v2/programs/\\d+/stats',
        '/loyalty/v3/programs',
        '/loyalty/v3/programs',
        '/loyalty/v3/programs/\\d+',
        '/loyalty/v3/programs/\\d+/deactivate',
        '/loyalty/v3/programs/\\d+/reactivate',
        '/loyalty/v3/programs/\\d+/reset',
        '/loyalty/v3/programs/\\d+/stats',
      ],
      sub_menu: 'Loyalty Program',
      sub_menu_name: 'Loyalty Program',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 25,
      priority_rank: 250,
      menu: 'Employees',
      menu_name: 'Manage Employees',
      access: 'Back-office',
      level: 2,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/employees/staff',
        '/account/v1/employees',
        '/account/v1/employees',
        '/account/v1/employees/\\d+',
        '/account/v1/employees/\\d+',
        '/account/v1/roles',
        '/account/v1/employees/\\d+/permissions',
        '/api/v1/employees/resend_invitation',
        '/account/v1/slots',
        '/account/v1/slots/\\d+',
      ],
      sub_menu: 'Employee Slots',
      sub_menu_name: 'Employee Slots',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 26,
      priority_rank: 260,
      menu: 'Employees',
      menu_name: 'Manage Employees',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/employees/role',
        '/account/v1/roles',
        '/account/v1/roles',
        '/account/v1/roles/\\d+',
        '/account/v1/roles/\\d+',
        '/account/v1/employees/\\d+/permissions',
      ],
      sub_menu: 'Employee Access',
      sub_menu_name: 'Employee Access',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 27,
      priority_rank: 270,
      menu: 'Employees',
      menu_name: 'Manage Employees',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/employees/pin',
        '/account/v1/employees',
        '/account/v1/permissions/settings/pin',
        '/account/v1/permissions/settings/pin',
        '/account/v1/roles',
        '/account/v1/employees/\\d+/permissions',
      ],
      sub_menu: 'PIN Access',
      sub_menu_name: 'PIN Access',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 31,
      priority_rank: 530,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/outlets/list',
        '/api/v1/billings',
        '/api/v1/billings/outlet_price',
        '/api/v1/outlets',
        '/api/v1/outlets',
        '/api/v1/outlets/\\d+',
        '/api/v1/outlets/\\d+',
        '/v1/outlets/new',
      ],
      sub_menu: 'Outlets',
      sub_menu_name: 'Outlets',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 32,
      priority_rank: 510,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: ['/settings/accounts', '/api/v1/users/settings'],
      sub_menu: 'Account',
      sub_menu_name: 'Account',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 33,
      priority_rank: 520,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: [
        '/settings/billing',
        '/api/v1/billings',
        '/api/v1/billings/rules',
        '/api/v1/feature/get_feature_price_per_months',
        '/api/v1/feature/get_subscription_status',
      ],
      sub_menu: 'Billing',
      sub_menu_name: 'Billing',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 34,
      priority_rank: 540,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/settings/public_profile', '/api/v1/businesses/\\d+'],
      sub_menu: 'Public Profile',
      sub_menu_name: 'Public Profile',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 35,
      priority_rank: 550,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/settings/receipt', '/api/v1/outlets/\\d+'],
      sub_menu: 'Receipt',
      sub_menu_name: 'Receipts',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 36,
      priority_rank: 560,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/settings/checkout', '/api/v1/checkout_setting', '/api/v1/settings/update_settings'],
      sub_menu: 'Checkout',
      sub_menu_name: 'Checkout',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 37,
      priority_rank: 580,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/settings/email', '/api/v1/settings/update_settings', '/api/v1/settings'],
      sub_menu: 'Email Notification',
      sub_menu_name: 'Email Notifications',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 9,
      priority_rank: 90,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/promo',
        '/promo/v1/promos',
        '/promo/v1/promos',
        '/promo/v1/promos/outlets',
        '/promo/v1/promos/outlets/\\d+',
        '/promo/v1/promos/\\d+',
        '/promo/v1/promos/\\d+',
        '/api/v1/items/intersect_category_and_item_names',
        '/api/v1/items/intersect_item_variants',
        '/promo/v1/payments',
        '/promo/v1/payments',
        '/promo/v1/payments/\\d+',
        '/promo/v1/reports/category',
        '/promo/v1/reports/discount',
        '/promo/v1/reports/item',
        '/promo/v1/types',
        '/promo/v1/promos/\\d+',
      ],
      sub_menu: 'Promo',
      sub_menu_name: 'Promos',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 13,
      priority_rank: 130,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/library/sales_type',
        '/library/v1/sales-type',
        '/library/v1/sales-type/\\d+',
        '/library/v1/sales-type',
        '/library/v1/sales-type/all-outlet',
        '/library/v1/sales-type/\\d+',
        '/library/v1/sales-type/manage-state/\\d+',
        '/library/v1/sales-type/\\d+',
        '/library/v1/sales-type/check-deletable/\\d+',
      ],
      sub_menu: 'Sales Type',
      sub_menu_name: 'Sales Types',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 28,
      priority_rank: 280,
      menu: 'Table Management',
      menu_name: 'Manage Table Management',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/table-management/group',
        '/table-management/v1/table-groups',
        '/table-management/v1/table-groups',
        '/table-management/v1/table-groups/\\d+',
        '/table-management/v1/table-groups/\\d+',
        '/table-management/v1/table-groups/\\d+',
        '/table-management/v1/table-groups/\\d+',
      ],
      sub_menu: 'Table Group',
      sub_menu_name: 'Table Groups',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 29,
      priority_rank: 290,
      menu: 'Table Management',
      menu_name: 'Manage Table Management',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/table-management/map',
        '/table-management/v1/table-groups/\\d+/tables',
        '/table-management/v1/table-groups/\\d+/tables',
        '/table-management/v1/table-groups/\\d+/tables/\\d+',
      ],
      sub_menu: 'Table Map',
      sub_menu_name: 'Table Map',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 30,
      priority_rank: 300,
      menu: 'Table Management',
      menu_name: 'Manage Table Management',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [
        '/table-management/report',
        '/sync-bill/v1/bills/outlet/\\d+',
        '/sync-bill/v1/bills/outlet/\\d+/bill/\\d+',
        '/sync-bill/v1/bills/outlet/\\d+/summary',
        '/table-management/void-item-report',
      ],
      sub_menu: 'Table Report',
      sub_menu_name: 'Table Reports',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 50,
      priority_rank: 410,
      menu: 'Payments',
      menu_name: 'Payments',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/payments/payment_methods'],
      sub_menu: 'Mobile Payments',
      sub_menu_name: 'Mobile Payments',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 51,
      priority_rank: 305,
      menu: 'Partner Solutions',
      menu_name: 'Apps',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/apps/app-market', '/apps/my-app'],
      sub_menu: 'Apps',
      sub_menu_name: 'Apps',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 53,
      priority_rank: 307,
      menu: 'Capital',
      menu_name: 'Capital',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [
        '/capital',
        '/capital/v1/administrations/\\w+/updates',
        '/capital/v1/consents',
        '/capital/v1/consents',
        '/capital/v1/documents/\\d+/views',
        '/capital/v1/finalapprovals',
        '/capital/v1/finalapprovals/uploads',
        '/capital/v1/preapprovals',
        '/capital/v1/preapprovals',
        '/capital/v1/submissions',
        '/capital/v1/loan-eligibilities',
        '/capital/v1/submissions',
        '/capital/v1/finalapprovals',
        '/capital/term-loan',
        '/capital/fast-loan',
        '/capital/term-loan/conditions',
        '/capital/fast-loan/conditions',
        '/capital/fast-loan/status',
        '/capital/fast-loan/tenor',
      ],
      sub_menu: 'Capital',
      sub_menu_name: 'Capital',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 54,
      priority_rank: 533,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/settings/bank_account'],
      sub_menu: 'Bank Account',
      sub_menu_name: 'Bank Account',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 71,
      priority_rank: 420,
      menu: 'Payments',
      menu_name: 'Payments',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/payments/payment_configuration'],
      sub_menu: 'Payment Configuration',
      sub_menu_name: 'Payment Configuration',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 105,
      priority_rank: 272,
      menu: 'Customer Display',
      menu_name: 'Manage Customer Display',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/customer-display/settings'],
      sub_menu: 'Settings',
      sub_menu_name: 'Settings',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 90,
      priority_rank: 271,
      menu: 'Customer Display',
      menu_name: 'Manage Customer Display',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/customer-display/campaign'],
      sub_menu: 'Campaign',
      sub_menu_name: 'Campaign',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 72,
      priority_rank: 131,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/library/brands'],
      sub_menu: 'Brands',
      sub_menu_name: 'Brands',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 73,
      priority_rank: 211,
      menu: 'Online Channels',
      menu_name: 'Online Channels',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/online-store/gostore'],
      sub_menu: 'Moka Order',
      sub_menu_name: 'Moka Order',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 77,
      priority_rank: 85,
      menu: 'Library',
      menu_name: 'Manage Library',
      access: 'Back-office',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: ['/library/bundle-package'],
      sub_menu: 'Bundle Package',
      sub_menu_name: 'Bundle Package',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 87,
      priority_rank: 570,
      menu: 'Account Settings',
      menu_name: 'Manage Account Settings',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/settings/inventory'],
      sub_menu: 'Inventory',
      sub_menu_name: 'Inventory',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 89,
      priority_rank: 215,
      menu: 'Online Channels',
      menu_name: 'Online Channels',
      access: 'Back-office',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: ['/online-store/gofood'],
      sub_menu: 'GoFood',
      sub_menu_name: 'GoFood',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 85,
      priority_rank: 211,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Request Adjustments',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Request Adjustments',
      sub_menu_name: 'Request Adjustments',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 78,
      priority_rank: 191,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Request Purchase Order (PO)',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Request Purchase Order (PO)',
      sub_menu_name: 'Request PO',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 80,
      priority_rank: 193,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Fulfill Purchase Order (PO)',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Fulfill Purchase Order (PO)',
      sub_menu_name: 'Fulfillment PO',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 48,
      priority_rank: 460,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Cancel Invoice',
      sub_menu_name: 'Cancel Invoices',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 81,
      priority_rank: 201,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Create Transfer Request',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Create Transfer Request',
      sub_menu_name: 'Request Transfer',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 79,
      priority_rank: 192,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Approve Purchase Order (PO)',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Approve Purchase Order (PO)',
      sub_menu_name: 'Approve PO',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 42,
      priority_rank: 510,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Edit Customer List',
      sub_menu_name: 'Edit Customer Information',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 59,
      priority_rank: 480,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      description: 'Allow employees to view expected ending amounts and print current shifts',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'View and Print Current Shift Details',
      sub_menu_name: 'View and Print Current Shift Details',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 84,
      priority_rank: 204,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Fulfill Transfer Request',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Fulfill Transfer Request',
      sub_menu_name: 'Transfer Fulfillment',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 41,
      priority_rank: 420,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Manage Discount',
      sub_menu_name: 'Manage Discounts',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 44,
      priority_rank: 520,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      description: 'Required to complete transactions',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Manage Charge',
      sub_menu_name: 'Charge Customers',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 58,
      priority_rank: 470,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: [],
      sub_menu: 'View Shift History',
      sub_menu_name: 'View Shift History',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 86,
      priority_rank: 212,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Approve Adjustments',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Approve Adjustments',
      sub_menu_name: 'Approve Adjustments',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 49,
      priority_rank: 530,
      menu: 'Table Map',
      menu_name: 'Table Map',
      access: 'App',
      description: 'Only available in Table Management',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Move Table',
      sub_menu_name: 'Move Tables',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 45,
      priority_rank: 440,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Resend Receipt',
      sub_menu_name: 'Resend Receipts',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 60,
      priority_rank: 540,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: [],
      sub_menu: 'View Activity',
      sub_menu_name: 'View Activity',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 43,
      priority_rank: 400,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      description: 'Required to complete transactions',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Edit and Remove Open Bills',
      sub_menu_name: 'Manage All Open Bills',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 88,
      priority_rank: 10010,
      menu: 'No Menu',
      menu_name: 'No Menu',
      access: 'Endpoint',
      description: 'Permission only for owner',
      level: 1,
      pin_required: false,
      mobile_supported: false,
      usable: false,
      urls: [],
      sub_menu: 'Owner Access',
      sub_menu_name: 'No Menu',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 82,
      priority_rank: 202,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Approve Transfer Request',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Approve Transfer Request',
      sub_menu_name: 'Approve Transfer',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 39,
      priority_rank: 500,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Manage Favorites',
      sub_menu_name: 'Manage Favorites',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 57,
      priority_rank: 410,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: [],
      sub_menu: 'Apply Discounts to Bills and Items',
      sub_menu_name: 'Apply Discounts to Bills and Items',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 47,
      priority_rank: 450,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Record Payment for Invoice',
      sub_menu_name: 'Record Invoice Payments',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 46,
      priority_rank: 430,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Issue Refunds',
      sub_menu_name: 'Issue Refunds',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 83,
      priority_rank: 203,
      menu: 'No Menu',
      menu_name: 'Manage Inventory',
      access: 'Endpoint',
      description: 'Permission for Manage Inventory > Shipment Transfer Request',
      level: 3,
      pin_required: false,
      mobile_supported: false,
      usable: true,
      urls: [],
      sub_menu: 'Shipment Transfer Request',
      sub_menu_name: 'Transfer Shipment',
      is_allowed_for_moka_pay: false,
    },
    {
      id: 40,
      priority_rank: 490,
      menu: 'Register',
      menu_name: 'Register',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: true,
      urls: [],
      sub_menu: 'Manage Item Library',
      sub_menu_name: 'Manage Items',
      is_allowed_for_moka_pay: true,
    },
    {
      id: 56,
      priority_rank: 390,
      menu: 'Activity',
      menu_name: 'Activity',
      access: 'App',
      level: 3,
      pin_required: false,
      mobile_supported: true,
      usable: false,
      urls: [],
      sub_menu: 'Print Bill',
      sub_menu_name: 'Print Bills',
      is_allowed_for_moka_pay: true,
    },
  ],
  uniq_id: null,
  receipt_counter: null,
  invoice_counter: null,
  feature_subscription: [
    {
      feature_name: 'Loyalty',
      is_subscribing: false,
      feature_properties: [
        { name: 'LOYALTY_MEMBER_LIMIT', value: '100' },
        { name: 'CAN_RESET_LOYALTY_PROGRAM', value: 'false' },
      ],
      subscribing: false,
    },
    { feature_name: 'Table Management', is_subscribing: false, feature_properties: [], subscribing: false },
    { feature_name: 'Ingredient Inventory', is_subscribing: false, feature_properties: [], subscribing: false },
    {
      feature_name: 'Loyalty Pro',
      is_subscribing: false,
      feature_properties: [
        { name: 'LOYALTY_MEMBER_LIMIT', value: '-1' },
        { name: 'CAN_RESET_LOYALTY_PROGRAM', value: 'true' },
      ],
      subscribing: false,
    },
  ],
  hermes: null,
  has_saudagar_outlet: false,
};

const profileExpired = {
  ...profileSingleOutletData,
  business: { ...profileSingleOutletData.business, is_trial: false, expired_at: '2023-03-16 07:00:00.000+0700', has_expired: true },
  expired_at: '2023-03-16 07:00:00.000+0700',
};

const now = new Date();
const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);

const profileM6 = { ...profileMultiOutletData, business: { ...profileMultiOutletData.business, expired_at: nextMonth.toLocaleString() } };

export { profileMultiOutletData, profileSingleOutletData, profileTwoOutletData, profileThreeOutletData, profileExpired, profileM6 };
